import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex, themedColor, Box, TransitionPhase, useToggle, useClickOutside } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES, HamburgerIcon, DialogCloseIcon } from '@lemonade-hq/nuis';
import { useMemo, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { CSSTransition } from 'react-transition-group';
import styled, { css } from 'styled-components';
import { getHeaderLinksByCountryAndRegion } from '../../../helpers/links.esm.js';
import { HeaderContentLinks } from './HeaderContentLinks.esm.js';
import { headerMediaBreakpoint } from './shared.esm.js';
import { Cookie } from '../../../config/cookies.esm.js';

/* eslint-disable react/jsx-no-target-blank */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  content: '';\n  background: transparent url('https://s3.amazonaws.com/lmnd-images/icn-social.png') no-repeat ",
        "px ",
        "px;\n  background-size: 79px 52px;\n  position: absolute;\n  z-index: 1;\n  display: block;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      ",
        ";\n      width: 13px;\n      height: 25px;\n      top: calc(50% - 12px);\n      left: calc(50% - 7px);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      ",
        ";\n      width: 29px;\n      height: 29px;\n      top: calc(50% - 15px);\n      left: calc(50% - 15px);\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      content: '';\n      background: transparent\n        url('https://s3.amazonaws.com/edge-assets.lemonade.com/x-ea627cf93a86e17b3672a26cd4e3757e.svg') no-repeat center\n        center;\n      background-size: contain;\n      width: 30px;\n      height: 30px;\n      position: absolute;\n      z-index: 1;\n      display: block;\n      overflow: hidden;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 280px;\n  position: fixed;\n  z-index: 1000;\n  height: 100%;\n  background: ",
        ";\n  padding: 30px;\n  top: 0px;\n  left: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      @media ",
        " {\n        display: none;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: block;\n\n  button {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .bm-item-list {\n    display: flex;\n    flex-flow: column;\n    padding: 0;\n  }\n\n  .bm-item {\n    display: inherit !important;\n  }\n\n  ",
        " {\n    transform: translate(-100%, 0);\n\n    &.",
        " {\n      transform: translate(0, 0);\n      transition: transform ",
        "ms ease 0s;\n    }\n\n    &.",
        " {\n      transform: translate(0, 0);\n    }\n\n    &.",
        " {\n      transform: translate(0, 0);\n    }\n\n    &.",
        " {\n      transform: translate(-100%, 0);\n      transition: transform ",
        "ms ease 0s;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  background: transparent;\n  border: none;\n  padding: 0;\n  right: 8px;\n  top: 8px;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n\n  img {\n    margin: 2px 0 0 2px;\n    width: 12px;\n    height: 12px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 30px;\n  left: 27px;\n  right: 27px;\n  outline: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 57px;\n  height: 57px;\n  background-color: ",
        ";\n  transition: background-color 0.2s;\n  border-radius: 50%;\n\n  &:before {\n    ",
        ";\n  }\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n          left: 25px;\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n      position: fixed;\n      height: 30px;\n      left: 10px;\n      top: 19px;\n\n      ",
        "\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    cursor: pointer;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
var MENU_TRANSITION_TIME = 300;
var socialIcons = function(left, top) {
    return css(_templateObject(), left, top);
};
var socialConfig = {
    facebook: {
        link: "https://www.facebook.com/Lemonade/",
        aria: "Lemonade Facebook",
        style: css(_templateObject1(), socialIcons(0, -25))
    },
    instagram: {
        link: "https://instagram.com/lemonade_inc",
        aria: "Lemonade Instagram",
        style: css(_templateObject2(), socialIcons(-50, 0))
    },
    twitter: {
        link: "https://x.com/lemonade_inc",
        aria: "Lemonade X",
        style: css(_templateObject3())
    }
};
var platforms = Object.keys(socialConfig);
var MobileMenu = styled(Flex)(_templateObject4(), themedColor("nightRider"));
var BurgerMenuContainer = styled(Box)(_templateObject6(), MobileMenu, TransitionPhase.EnterActive, MENU_TRANSITION_TIME, TransitionPhase.EnterDone, TransitionPhase.Exit, TransitionPhase.ExitActive, MENU_TRANSITION_TIME, function(param) {
    var hideOnDesktop = param.hideOnDesktop;
    return hideOnDesktop && css(_templateObject5(), headerMediaBreakpoint);
});
var MobileMenuBtn = styled.button(_templateObject7());
var SocialOptions = styled(Flex)(_templateObject8());
var SocialLinkOption = styled(Box)(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.night;
}, function(props) {
    return socialConfig[props.platform].style;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ToggleButton = styled(Flex)(_templateObject12(), function(param) {
    var isFixed = param.isFixed;
    return isFixed && css(_templateObject11(), MEDIA_QUERIES.tablet(_templateObject10()));
});
var BurgerMenu = function(_param) {
    var routerHoc = _param.routerHoc, showLogin = _param.showLogin, _param_hideOnDesktop = _param.hideOnDesktop, hideOnDesktop = _param_hideOnDesktop === void 0 ? true : _param_hideOnDesktop, _param_isToggleFixed = _param.isToggleFixed, isToggleFixed = _param_isToggleFixed === void 0 ? true : _param_isToggleFixed, links = _param.links, htmlProps = _object_without_properties(_param, [
        "routerHoc",
        "showLogin",
        "hideOnDesktop",
        "isToggleFixed",
        "links"
    ]);
    var _useToggle = useToggle(), isOpen = _useToggle.isOpen, open = _useToggle.open, close = _useToggle.close, toggle = _useToggle.toggle;
    var ContentLinks = useMemo(function() {
        return routerHoc != null ? routerHoc(HeaderContentLinks) : HeaderContentLinks;
    }, [
        routerHoc
    ]);
    var wrapperRef = useRef(null);
    useClickOutside(wrapperRef, true, close);
    var _useCookies = _sliced_to_array(useCookies([
        Cookie.Geography
    ]), 1), cookies = _useCookies[0];
    var resolvedLinks = useMemo(function() {
        return links !== null && links !== void 0 ? links : getHeaderLinksByCountryAndRegion(cookies[Cookie.Geography]);
    }, [
        links,
        cookies
    ]);
    return /*#__PURE__*/ jsxs(BurgerMenuContainer, _object_spread_props(_object_spread({}, htmlProps), {
        hideOnDesktop: hideOnDesktop,
        children: [
            /*#__PURE__*/ jsx(ToggleButton, {
                alignItems: "center",
                "aria-controls": "menu",
                "aria-label": "Open the menu",
                isFixed: isToggleFixed,
                justifyContent: "center",
                onClick: open,
                role: "button",
                width: 30,
                children: /*#__PURE__*/ jsx(HamburgerIcon, {})
            }),
            /*#__PURE__*/ jsx(CSSTransition, {
                className: MobileMenu,
                in: isOpen,
                timeout: MENU_TRANSITION_TIME,
                unmountOnExit: true,
                children: /*#__PURE__*/ jsxs(MobileMenu, {
                    ref: wrapperRef,
                    role: "menu",
                    children: [
                        /*#__PURE__*/ jsx(MobileMenuBtn, {
                            onClick: close,
                            children: /*#__PURE__*/ jsx(DialogCloseIcon, {})
                        }),
                        /*#__PURE__*/ jsx(ContentLinks, {
                            isInMenu: true,
                            links: resolvedLinks,
                            onLinkClicked: toggle,
                            withLogin: showLogin
                        }),
                        /*#__PURE__*/ jsx(SocialOptions, {
                            alignItems: "center",
                            justifyContent: "space-around",
                            children: platforms.map(function(platform) {
                                var _socialConfig_platform = socialConfig[platform], link = _socialConfig_platform.link, aria = _socialConfig_platform.aria;
                                return /*#__PURE__*/ jsx("a", {
                                    "aria-label": aria,
                                    href: link,
                                    rel: "noopener",
                                    role: "menuitem",
                                    target: "_blank",
                                    children: /*#__PURE__*/ jsx(SocialLinkOption, {
                                        platform: platform
                                    })
                                }, platform);
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

export { BurgerMenu, ToggleButton };
